import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4acf7676"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "送信した資料を再利用して送信する", -1))
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "資料を一件ずつ送信", -1))
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = { class: "content has-background-contents shadow" }
const _hoisted_9 = { class: "navigation" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" トップページに戻る ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_OuterInputComplete = _resolveComponent("OuterInputComplete")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.reuseFlag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Breadcrumb, {
                list: _ctx.reuseList,
                pageNum: 5
              }, null, 8, ["list"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Breadcrumb, {
                list: _ctx.list,
                pageNum: 4
              }, null, 8, ["list"])
            ])
          ])),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_OuterInputComplete)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        to: "/dms/outer",
        class: "button-toTop"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DssIcon, { icon: 'arrow-left' }),
          _hoisted_10
        ]),
        _: 1
      })
    ])
  ], 64))
}